export const EMBEDDING_PARAMS = [
    {
        name: 20,
        params: {
            state: 'enabled',
            financial_year: 'enabled',
            scheme: 'enabled',
            district: 'enabled'
        }
    },
    {
        name: 21,
        params: {
            state: 'enabled',
            financial_year: 'enabled',
            scheme: 'enabled',
            district: 'enabled'
        }
    },
    {
        name: 23,
        params: {
            // state: 'enabled',
            financial_year: 'enabled',
            scheme: 'enabled'
            // district: 'enabled'
        }
    },
    {
        name: 46,
        params: {
            state: 'enabled',
            district: 'enabled'
        }
    },
    {
        name: 48,
        params: {
            state: 'enabled',
            district: 'enabled'
        }
    }
];

export const REPORT_IDS: Record<string, number> = {
    CHC: 117,
    PG: 118,
    PE: 119,
    IFC: 115,
    EEP: 155
};
